<template>
<div v-if="stored">
  Un mail vous a été envoyé
</div>
  <div v-else>
    <div>
      <label>
        <!-- Numéro courtier ou  -->
        L'adresse mail
      </label>
      <a-input v-model:value="email" @keyup.enter="createUser()"></a-input>
    </div>
    <div style="text-align: right; margin-top: 10px">
      <a-button
        @click="createUser()"
        :loading="loading"
        type="primary"
        shape="round"
        ghost
      >
        Créer un compte
      </a-button>
    </div>
  </div>
</template>


<script>
export default {
  name: "createUser",
  props: {
    errorData: {
      type: Object,
    },
  },
  data: () => {
    return {
      loading: false,
      stored: false,
      email: "",
    };
  },
  methods: {
    async createUser() {
      this.loading = true;
      this.errorData.show = false;
      await this.axios
        .post("/auth/store", { email: this.email })
        .then((r) => {
          if(r.status === 201){
            this.stored = true;
          }
        })
        .catch((e) => {
          this.errorData.message = e.response.data.message;
          this.errorData.is_courtier = e.response.data.is_courtier;
          this.errorData.show = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
